<form [formGroup]="form" class="container">
  <app-titulo>Fechamento do Caixa</app-titulo>
  <div class="texts">
    <div>
      <strong>Início da abertura do caixa: </strong>
      <span>{{ dadosFechamento.DATA_ABERTURA }}</span>
    </div>
    <div>
      <strong>Previsão de Fechamento: </strong>
      <span>{{ dadosFechamento.PREVISAO_FECHAMENTO }}</span>
    </div>
    <div>
      <strong>Valor de Abertura: </strong>
      <span>{{ dadosFechamento.VALOR_ABERTURA }}</span>
    </div>
    <div class="separamento">
      <strong>Data de Fechamento: </strong>
      <span>{{ dadosFechamento.DATA_FECHAMENTO }}</span>
    </div>
    <div>
      <strong>Valor de Fechamento: </strong>
      <span>{{ dadosFechamento.VALOR_FECHAMENTO }}</span>
    </div>
    <div class="inputs">
      <app-input
        type="money"
        label="Valor em dinheiro"
        name="VL_FECH_DINH_CAIX"
        formControlName="VL_FECH_DINH_CAIX"
        placeholder="Digite aqui"
        [requiredInput]="true"
        width="100%"></app-input>
      <app-input
        type="money"
        label="Valor em débito"
        name="VL_FECH_DEBT_CAIX"
        formControlName="VL_FECH_DEBT_CAIX"
        placeholder="Digite aqui"
        [requiredInput]="true"
        width="100%"></app-input>
      <app-input
        type="money"
        label="Valor em crédito"
        name="VL_FECH_CRDT_CAIX"
        formControlName="VL_FECH_CRDT_CAIX"
        placeholder="Digite aqui"
        [requiredInput]="true"
        width="100%"></app-input>
      <app-input
        type="money"
        label="Valor em pix"
        name="VL_FECH_PIX_CAIX"
        formControlName="VL_FECH_PIX_CAIX"
        placeholder="Digite aqui"
        [requiredInput]="true"
        width="100%"></app-input>
      <app-input
        type="money"
        label="Valor a prazo"
        name="VL_FECH_APRZ_CAIX"
        formControlName="VL_FECH_APRZ_CAIX"
        placeholder="Digite aqui"
        [requiredInput]="true"
        width="100%"></app-input>
    </div>
    <h3>Tem certeza que deseja realizar o fechamento do caixa?</h3>
    <p>Essa ação não poderá ser desfeita.</p>
  </div>
  <div class="buttons">
    <app-botao text="Cancelar" bgColor="#B91C1C" (click)="onCancelar()" />
    <app-botao
      text="Confirmar"
      [bgColor]="!form.valid ? '' : '#059669'"
      (click)="postFechamento()"
      [disabled]="!form.valid || isLoading" />
  </div>
</form>

<app-loader *ngIf="isLoading" />
